(() => {
  'use strict';
  const init = () => {
    const page = document.querySelector('[data-av-service]');
    if (!page || page.dataset.servicesReady) return;
    page.dataset.servicesReady = 'true';
    const config = JSON.parse(document.getElementById('VoltturiServiceConfig').textContent);
    const languages = JSON.parse(document.getElementById('VoltturiTranslations').textContent);
    const language = () => languages[document.documentElement.lang] ? document.documentElement.lang : 'ja';
    const t = key => languages[language()].services[key];
    // Preserve alternate template URLs after the Shopify localization redirect.
    const localization = document.getElementById('VoltturiLocalization');
    if (localization?.elements.return_to) localization.elements.return_to.value = location.pathname + location.search;

    const form = page.querySelector('[data-av-subscription-form]');
    if (form) {
      let busy = false;
      const button = form.querySelector('[type="submit"]');
      const message = form.querySelector('[data-av-subscription-status]');
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const email = form.elements.email.value.trim();
        busy = true; button.disabled = true; form.setAttribute('aria-busy','true');
        const label = button.textContent; button.textContent = t('sending');
        message.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 30000);
        try {
          // This is Loop's public customer login endpoint, used by the supplied page.
          // Only the current merchant's domain is sent; no source-shop tokens are reused.
          const response = await fetch('https://api.loopwork.co/api/customer/v2/send_login_link_email', {
            method:'POST', credentials:'omit', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({email, myshopify_domain:config.shop}), signal:controller.signal
          });
          const result = await response.json();
          const ok = response.ok && result.success === true;
          message.textContent = t(ok ? 'sent' : 'send_error');
          message.dataset.state = ok ? 'success' : 'error';
        } catch (_) {
          message.textContent = t('network'); message.dataset.state = 'error';
        } finally {
          clearTimeout(timeout); busy = false; button.disabled = false;
          form.removeAttribute('aria-busy'); button.textContent = label; message.hidden = false;
        }
      });
    }

    const tracking = document.getElementById('pp-tracking-init-data');
    if (tracking) {
      const data = JSON.parse(tracking.textContent);
      const origin = config.origin || location.origin;
      Object.assign(data, {shop:config.shop, shopifyUrl:origin, proxyUrl:origin+'/apps/track-order', moneyFormat:config.moneyFormat || data.moneyFormat});
      Object.assign(data.translation, languages[language()].tracking);
      if (languages[language()].tracking.features_text) {
        data.custom_status = data.custom_status.map((status, i) => ({...status, ...languages[language()].tracking.features_text.custom_status[i]}));
      }
      const content = data.theme_config.content;
      content.top_section.image_banner.image.url = config.banner;
      content.bottom_section.images.forEach((item, i) => {
        item.image.url = config.images[i]; item.destination_url = config.root+'#aurivita-offer';
      });
      tracking.textContent = JSON.stringify(data);
      window.ParcelPanelApp = {
        ...(window.ParcelPanelApp || {}), locale:language(), moneyFormat:data.moneyFormat,
        routes:{domain:origin, origin, pathPrefix:'/apps/track-order', root:config.root}
      };
      const script = document.createElement('script');
      script.src = config.trackingScript;
      script.onerror = () => {
        const status = page.querySelector('[data-av-tracking-status]');
        status.textContent = t('track_error'); status.hidden = false;
      };
      document.head.append(script);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
